@if (onkoYritysmuodolleJaVuodelleLomakkeistoObservable | async) {
  @if (erottavatTilitObservable | async; as erottavatTilit) {
    <div>
      <div class="error-text" style="margin: 1em 1em 1em 0; font-size: 120%">Kaikkia kirjanpidon saldoja ei pystytty siirtämään veroilmoitukselle. Seuraavien tilien saldot pitää syöttää käsin:</div>
      <table style="margin: 1em">
        <tr>
          <th style="min-width: 50px; text-align: left">Tili</th>
          <th style="min-width: 300px; text-align: left">Nimi</th>
          <th>Debet</th>
          <th>Kredit</th>
          <th>Erotus</th>
        </tr>
        @for (tili of erottavatTilit; track tili) {
          <tr>
            <td style="padding: 0 10px 0 0">{{ tili.tili.numero }}</td>
            <td style="padding: 0 10px">{{ tili.tili.nimi }}</td>
            <td style="padding: 0 10px; text-align: right">{{ tili.debit | lmoney | async }}</td>
            <td style="padding: 0 10px; text-align: right">{{ tili.kredit | lmoney | async }}</td>
            <td style="padding: 0 0 0 10px; text-align: right">{{ tili.debit - tili.kredit | lmoney | async }}</td>
          </tr>
        }
      </table>
    </div>
  }
  @if (ilmoitinErrorsObservable | async; as errors) {
    <div>
      <div class="error-text" style="margin: 1em 1em 1em 0; font-size: 120%">Veroilmoitusta ei voi lähettää seuraavien virheiden takia:</div>
      @for (error of errors; track error) {
        <div>
          Kentät:
          @for (field of error.fields; track field) {
            <app-button (click)="avaaKentta(field)" actionId="Katso veroilmoituksen virhekenttä">
              {{ field }}
            </app-button>
          }
          <pre style="margin: 0.5em 0 2em 1em; font-size: 12px; line-height: 14px; white-space: pre-line">{{ error.message }}</pre>
        </div>
      }
    </div>
  }
  <!-- <button mat-button (click)="lataaDraftVeroilmoitus()" class="secondarybutton">
  Lataa nykyinen, lähettämätön veroilmoitus
</button> -->
  @if (yhtiomuotoJaVuosiObservable | async; as yhtiomuotoJaVuosi) {
    @if (yhtiomuotoJaVuosi.y === 't') {
      @if (lukittuObservable | async) {
        <div style="padding: 20px" class="red-text">
          <div>Vuoden {{ yhtiomuotoJaVuosi.v }} veroilmoitusten lähettäminen on päättynyt. Muutokset ilmoituksiin on hoidettava järjestelmän ulkopuolella tehtävällä oikaisuvaatimuksella.</div>
        </div>
      }
      @if (yhtiomuotoJaVuosi.v === 2020) {
        <div app-kirjanpito-veroilmoitus-tmi-2020 (laskeUudelleen)="laskeUudelleen()" (tallennaArvo)="tallennaArvo($event)" [lukittu]="lukittuObservable | async" [veroilmoitusObservable]="veroilmoitusObservable">
          <ng-container *ngTemplateOutlet="laheta"></ng-container>
        </div>
      }
      @if (yhtiomuotoJaVuosi.v === 2021) {
        <div app-kirjanpito-veroilmoitus-tmi-2021 (laskeUudelleen)="laskeUudelleen()" (tallennaArvo)="tallennaArvo($event)" [lukittu]="lukittuObservable | async" [veroilmoitusObservable]="veroilmoitusObservable">
          <ng-container *ngTemplateOutlet="laheta"></ng-container>
        </div>
      }
      @if (yhtiomuotoJaVuosi.v === 2022) {
        <div app-kirjanpito-veroilmoitus-tmi-2022 (laskeUudelleen)="laskeUudelleen()" (tallennaArvo)="tallennaArvo($event)" [lukittu]="lukittuObservable | async" [veroilmoitusObservable]="veroilmoitusObservable">
          <ng-container *ngTemplateOutlet="laheta"></ng-container>
        </div>
      }
      @if (yhtiomuotoJaVuosi.v === 2023) {
        <div app-kirjanpito-veroilmoitus-tmi-2023 (laskeUudelleen)="laskeUudelleen()" (tallennaArvo)="tallennaArvo($event)" [lukittu]="lukittuObservable | async" [veroilmoitusObservable]="veroilmoitusObservable">
          <ng-container *ngTemplateOutlet="laheta"></ng-container>
        </div>
      }
      @if (yhtiomuotoJaVuosi.v === 2024) {
        <div app-kirjanpito-veroilmoitus-tmi-2024 (laskeUudelleen)="laskeUudelleen()" (tallennaArvo)="tallennaArvo($event)" [lukittu]="lukittuObservable | async" [veroilmoitusObservable]="veroilmoitusObservable">
          <ng-container *ngTemplateOutlet="laheta"></ng-container>
        </div>
      }
      @if (yhtiomuotoJaVuosi.v === 2025) {
        <div app-kirjanpito-veroilmoitus-tmi-2025 (laskeUudelleen)="laskeUudelleen()" (tallennaArvo)="tallennaArvo($event)" [lukittu]="lukittuObservable | async" [veroilmoitusObservable]="veroilmoitusObservable">
          <ng-container *ngTemplateOutlet="laheta"></ng-container>
        </div>
      }
    }
    @if (yhtiomuotoJaVuosi.y === 'o') {
      @if (lukittuObservable | async) {
        <div style="padding: 20px" class="red-text">
          <div>Vuoden {{ yhtiomuotoJaVuosi.v }} veroilmoitusten lähettäminen on päättynyt. Muutokset ilmoituksiin on hoidettava järjestelmän ulkopuolella tehtävällä oikaisuvaatimuksella.</div>
        </div>
      }
      @if (yhtiomuotoJaVuosi.v === 2020) {
        <div app-kirjanpito-veroilmoitus-oy-2020 (laskeUudelleen)="laskeUudelleen()" (tallennaArvo)="tallennaArvo($event)" [lukittu]="lukittuObservable | async" [veroilmoitusObservable]="veroilmoitusObservable">
          <ng-container *ngTemplateOutlet="laheta"></ng-container>
        </div>
      }
      @if (yhtiomuotoJaVuosi.v === 2021) {
        <div app-kirjanpito-veroilmoitus-oy-2021 (laskeUudelleen)="laskeUudelleen()" (tallennaArvo)="tallennaArvo($event)" [lukittu]="lukittuObservable | async" [veroilmoitusObservable]="veroilmoitusObservable">
          <ng-container *ngTemplateOutlet="laheta"></ng-container>
        </div>
      }
      @if (yhtiomuotoJaVuosi.v === 2022) {
        <div app-kirjanpito-veroilmoitus-oy-2022 (laskeUudelleen)="laskeUudelleen()" (tallennaArvo)="tallennaArvo($event)" [lukittu]="lukittuObservable | async" [veroilmoitusObservable]="veroilmoitusObservable">
          <ng-container *ngTemplateOutlet="laheta"></ng-container>
        </div>
      }
      @if (yhtiomuotoJaVuosi.v === 2023) {
        <div app-kirjanpito-veroilmoitus-oy-2023 (laskeUudelleen)="laskeUudelleen()" (tallennaArvo)="tallennaArvo($event)" [lukittu]="lukittuObservable | async" [veroilmoitusObservable]="veroilmoitusObservable">
          <ng-container *ngTemplateOutlet="laheta"></ng-container>
        </div>
      }
      @if (yhtiomuotoJaVuosi.v === 2024) {
        <div app-kirjanpito-veroilmoitus-oy-2024 (laskeUudelleen)="laskeUudelleen()" (tallennaArvo)="tallennaArvo($event)" [lukittu]="lukittuObservable | async" [veroilmoitusObservable]="veroilmoitusObservable">
          <ng-container *ngTemplateOutlet="laheta"></ng-container>
        </div>
      }
      @if (yhtiomuotoJaVuosi.v === 2025) {
        <div app-kirjanpito-veroilmoitus-oy-2025 (laskeUudelleen)="laskeUudelleen()" (tallennaArvo)="tallennaArvo($event)" [lukittu]="lukittuObservable | async" [veroilmoitusObservable]="veroilmoitusObservable">
          <ng-container *ngTemplateOutlet="laheta"></ng-container>
        </div>
      }
      @if (yhtiomuotoJaVuosi.v === 2026) {
        <div app-kirjanpito-veroilmoitus-oy-2026 (laskeUudelleen)="laskeUudelleen()" (tallennaArvo)="tallennaArvo($event)" [lukittu]="lukittuObservable | async" [veroilmoitusObservable]="veroilmoitusObservable">
          <ng-container *ngTemplateOutlet="laheta"></ng-container>
        </div>
      }
    }
  }
  @if (naytaLataaIlmoitusObservable | async) {
    <div>
      <app-secondary-button (click)="lataaDraftVeroilmoitus()" actionId="Lataa veroilmoituksen ilmoitin.fi siirtotiedosto koneelle (Sisältää tallentamattomat muutokset)" styles="margin: 25px 0;"> Lataa veroilmoituksen ilmoitin.fi siirtotiedosto (Sisältää tallentamattomat muutokset) </app-secondary-button>
      <app-secondary-button (click)="downloadUnsavedPdf()" actionId="Lataa veroilmoitus PDF koneelle (Sisältää tallentamattomat muutokset)" styles="margin-bottom: 25px;"> Lataa veroilmoitus PDF (Sisältää tallentamattomat muutokset) </app-secondary-button>
    </div>
  }
} @else {
  @if (onkoYhtiomuotoTuettuObservable | async) {
    <div style="text-align: center; margin: 25px 0">Tämän vuoden lomakkeistoa ei ole vielä tehty. Tarkista myöhemmin uudelleen.</div>
  } @else {
    <div style="text-align: center; margin: 25px 0">Automaattista veroilmoitusta ei tueta tälle yhtiömuodolle, tee veroilmoitus manuaalisesti OmaVerossa.</div>
  }
}

<ng-template #laheta>
  @if (!(lukittuObservable | async)) {
    <!-- <div style="text-align: center; padding-top: 40px;" class="laheta-tab-title">Lähetä veroilmoitus verohallinnolle</div>
    <div *ngIf="commonErrorObservable | async; as commonError" class="error-text" style="font-size: 120%; line-height: 120%; padding: 15px;">{{commonError}}</div>
    <div style="text-align: center; margin-bottom: 30px;">
      <app-primary-button (click)="tallennaVeroilmoitus()" actionId="Lähetä veroilmoitus">
        Lähetä
      </app-primary-button>
    </div> -->
    <ng-container *ngTemplateOutlet="aikaisemminLahetetyt"></ng-container>
    <div app-veroilmoitus-lahetys [account9940DebetMinusKreditSumObservable]="account9940DebetMinusKreditSumObservable" [voiLahettaaObservable]="veroilmoitussahkoopostinVoiLahettaaObservable" [perustiedotObservable]="perustiedotObservable" [viimeisinLahetettyVeroilmoitusObservable]="viimeisinLahetettyVeroilmoitusObservable"></div>
  } @else {
    <ng-container *ngTemplateOutlet="aikaisemminLahetetyt"></ng-container>
    <div app-veroilmoitus-aikaisemmin-lahetetyt-spostit [perustiedotObservable]="perustiedotObservable"></div>
  }
</ng-template>

<ng-template #aikaisemminLahetetyt>
  <div style="padding-bottom: 30px">
    <div class="laheta-tab-title" style="text-align: center">Aikaisemmin lähetetyt veroilmoitukset</div>
    @if (aikaisemmatVeroilmoituksetObservable | async; as aikaisemmatVeroilmoitukset) {
      @if (aikaisemmatVeroilmoitukset.lahetetyt.length > 0) {
        <table style="margin: 0 auto">
          <tr>
            <th>Lähetetty</th>
            <th>Lähettäjä</th>
            <th>Lataa siirtotiedosto</th>
            <th>Lataa PDF</th>
            @if (aikaisemmatVeroilmoitukset.devaaja) {
              <th>Data</th>
            }
          </tr>
          @for (ilmo of aikaisemmatVeroilmoitukset.lahetetyt; track ilmo) {
            <tr>
              <td style="padding: 0 10px 0 0">{{ ilmo.lahetetty }}</td>
              <td style="padding: 0 10px">{{ ilmo.lahettaja }}</td>
              <td style="padding: 0 10px">
                <app-secondary-button (click)="lataaTyviTiedosto(ilmo)" actionId="Lataa siirtotiedosto koneelle (aikaisemmin lähetetyt veroilmoitukset)"> Lataa siirtotiedosto </app-secondary-button>
              </td>
              <td style="padding: 0 0 0 10px">
                <app-secondary-button (click)="downloadPdf(ilmo)" actionId="Lataa PDF koneelle (aikaisemmin lähetetyt veroilmoitukset)"> Lataa PDF </app-secondary-button>
              </td>
              @if (aikaisemmatVeroilmoitukset.devaaja) {
                <td>
                  <a [href]="ilmo.dataLinkEncoded" target="_BLANK">Firestore</a>
                </td>
              }
            </tr>
          }
        </table>
      } @else {
        <div style="text-align: center; padding: 25px">Tilikaudella ei ole vielä lähetetty yhtään veroilmoitusta.</div>
      }
    } @else {
      <div style="text-align: center; padding: 50px 0">
        <mat-spinner style="display: inline-block"></mat-spinner>
      </div>
    }
  </div>
</ng-template>

@if (kirjanpitajaOnDevaajaObservable | async) {
  <div style="margin: 25px 0">
    <h3 style="margin: 0">Urit</h3>
    <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
      Käyttäjän tallentamat tiedot: <a [href]="veroilmoitusEncodedUriObservable | async" target="_BLANK">{{ veroilmoitusUriObservable | async }}</a>
    </div>
    <div style="font-size: 80%; color: darkgray">
      <h2 style="margin: 40px 0 10px 0">Punakynä arvot</h2>
      @for (entry of veroilmoitusPunakynaEntries; track entry) {
        <div>{{ entry[0] }}: {{ entry[1] }}</div>
      }
      <h2 style="margin: 40px 0 10px 0">Ei tallennettu</h2>
      @for (entry of veroilmoitusEiTallennettuEntries; track entry) {
        <div>{{ entry[0] }}: {{ entry[1] | json }}</div>
      }
      <h2 style="margin: 40px 0 10px 0">Muokatut arvot</h2>
      @for (entry of veroilmoitusEditableEntries; track entry) {
        <div>{{ entry[0] }}: {{ entry[1] }}</div>
      }
      <h2 style="margin: 40px 0 10px 0">Lähetettävä veroilmoitus</h2>
      @for (entry of veroilmoitusStaticEntries; track entry; let i = $index) {
        <div>{{ i }}: {{ entry.key }}: {{ entry.value }}</div>
      }
      <h2 style="margin: 40px 0 10px 0">Oletukset</h2>
      @for (entry of veroilmoitusOletuksetEntries; track entry) {
        <div>{{ entry[0] }}: {{ entry[1] }}</div>
      }
      <!-- <h2 style="margin: 40px 0 10px 0;">Tilikauden tilien summat</h2>
      <div>Avain on muotoa
        <pre style="display: inline-block; background-color: bisque; padding: 0 5px;">'t' + tilinumero + k|d</pre>,
        jossa k = kredit, d = debit
      </div>
      <div *ngFor="let smt of tilikaudenSummatEntries">
        <div>{{smt.kuvaus}}</div>
        <ng-container *ngFor="let entry of smt.summat">
          {{ entry[0] }}: {{ entry[1] }},
        </ng-container>
      </div>
      <h2 style="margin: 40px 0 10px 0;">Kalenterivuoden tilien summat</h2>
      <ng-container *ngFor="let entry of kalenterivuodenSummatEntries">
        <div>{{ entry[0] }}: {{ entry[1] }}</div>
      </ng-container> -->
    </div>
  </div>
}
